import { useState } from 'react'
import { Button, Input } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import {
  caseAtom,
  orderAtom,
  hasNewCaseAtom,
  delayNestedObjectInputAtom,
} from 'atoms'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'hooks'
import { useErrorHandler } from 'hooks/utility/useErrorHandler'
import { useTranslation } from 'react-i18next'
import { createCase as createCaseApi } from '@/api/cases'
import { createOrder } from '@/api/orders'

export const NewCaseModal = ({
  setShowButtonModal,
  setShowCaseModal,
  type,
  onSave,
  getItems,
}) => {
  const { t } = useTranslation()
  const handleError = useErrorHandler('NewCaseModal')
  const [nameOfDeceased, setNameOfDeceased] = useState('')
  const setCase = useSetRecoilState(caseAtom)
  const setOrder = useSetRecoilState(orderAtom)
  const setHasNewCase = useSetRecoilState(hasNewCaseAtom)
  const turnOnDelay = useSetRecoilState(delayNestedObjectInputAtom)

  const navigate = useNavigate()

  const createCase = async () => {
    try {
      const payload = { name_of_deceased: nameOfDeceased }
      const { data: caseData } = await createCaseApi(payload)
      setCase(caseData)
      setShowButtonModal(false)

      if (type === 'Case') {
        setShowCaseModal(true)
        getItems(false)
      }

      if (type === 'Order') {
        const { data: orderData } = await createOrder({
          case_id: caseData.id,
        })
        setOrder(orderData)
        setHasNewCase(true)
        turnOnDelay(true)
        navigate(`/package/${orderData.id}/products`)
      }

      if (type === 'duplicate') {
        setShowButtonModal(false)
        onSave?.(caseData.id)
      }
    } catch (error) {
      handleError(error?.response?.data?.message || error.message, error)
    }
  }

  return (
    <Flex column full padding="32px">
      <Text size="24px" weight="600" margin="0 0 20px 0">
        {t('createNewCaseModal.title')}
      </Text>
      <Input
        full
        label={t('createNewCaseModal.nameOfDeceasedLabel')}
        placeholder={t('createNewCaseModal.namePlaceholder')}
        value={[nameOfDeceased, setNameOfDeceased]}
        margin="0 0 24px 0"
        data-testid="new-case-name-input"
      />
      <Flex justify="flex-end" margin="24px 0 0 0">
        <Button margin="0 16px 0 0" onClick={setShowButtonModal}>
          {t('createNewCaseModal.cancelButton')}
        </Button>

        <Button
          left
          primary
          margin="0 12px 0 0"
          onClick={() => createCase()}
          data-testid="new-case-create-button"
        >
          {t('createNewCaseModal.createButton')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default NewCaseModal
